/**
 * PROJECT-EDIT-END.MODAL
 * Set end date for a project
 */

import { withTranslation, WithTranslation } from "react-i18next"
import { connect } from "react-redux"
import Modal from "@/components/modal"
import { ProjectState } from "@/redux/project.types"
import { useState } from "react"
import { store } from "@/index"
import { projectEdit } from "@/redux/project.actions"
import TextInput from "@/components/text-input"
import { formatDate, updateDate } from "@/utils/format-date.utils"
import { SendingState } from "@/redux/sending.types"
import TimePicker from "react-time-picker"

interface StateProps extends WithTranslation {
  project: ProjectState
  sending: SendingState
}

interface OwnProps {
  date: Date
  onClose: Function
}

type Props = StateProps & OwnProps

function ProjectEditEndModal(props: Props) {
  const { t } = props

  function initDate() {
    if (props.project.active.surveyDateEnd) {
      return new Date(props.project.active.surveyDateEnd)
    }

    if (props.date) {
      const d = new Date(props.date)
      d.setHours(23, 0, 0, 0)
      return d
    }

    const d = new Date()
    d.setDate(d.getDate() + 30)
    d.setHours(23, 0, 0, 0)
    return d
  }

  const [date, setDate] = useState<Date>(initDate())

  async function next() {
    if (
      props.project.active.isDateEndValid(
        date,
        props.sending.list.map((x) => x.date)
      )
    ) {
      store.dispatch(projectEdit("surveyDateEnd", date))
      props.onClose()
    }
  }

  async function deleteEnd() {
    store.dispatch(projectEdit("surveyDateEnd", null))
    props.onClose()
  }

  return (
    <Modal
      title={t("reminder_tag_end")}
      isCloseButtonVisible
      disableKeyEvents
      disableClickOutside
      status={props.project.status}
      onClose={() => props.onClose()}
      onDelete={() => deleteEnd()}
      onNext={next}>
      <p className="grey-t">{t("reminder_description_end")}</p>

      <div className="flex">
        <TextInput
          type="date"
          isFullWidth
          onChange={(e) => setDate(updateDate(date, new Date(e.value), true, null))}
          title={t("reminder_date")}
          value={formatDate(date, false, true)}
        />

        <div className="width-20" />

        <div>
          <div className="text-input-title grey-t">{t("reminder_hour")}</div>

          <TimePicker
            onChange={(time) => {
              if (time) {
                setDate(new Date(new Date(date).toDateString() + " " + time))
              }
            }}
            // value={date.toTimeString().split(" ")[0]}
            value={date.toTimeString().slice(0, 5)}
            disableClock={true}
          />
        </div>

        <div className="width-20" />
      </div>

      <div className="height-20" />
    </Modal>
  )
}

const mapStateToProps = (state) => ({
  project: state.project,
  sending: state.sending
})

export default connect(mapStateToProps)(withTranslation()(ProjectEditEndModal))
